import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService, UserService } from '../../../../services/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SalesService } from '../../sales.service';
import { referenceList, coApplicantColDefs, familyColDefs, IAllotment, IFormInfo, nomineeColDefs, otherChargesColDefs, paymentSchedule, References, summaryTreeNodes, UsersCategory, Users, summaryColumnDefs, summaryData, otherChargesColumnDefs } from './allotment-addupdate.model';
import { FormIdentity } from "../../../../common-components/common-form/common-form.model";
import { environment } from '../../../../../environments/environment';
import { IconList } from '../../../../../iconlist';
import { AddressType, AmountSubTypes, UserSubType } from '../../../../../appconfig';
import { ICommonFormField } from '../../../../common-components/common-form/common-form.model';
import { TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { filter } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-allotment-addupdate',
  templateUrl: './allotment-addupdate.component.html',
  styleUrl: './allotment-addupdate.component.scss'
})
export class AllotmentAddupdateComponent implements OnInit, OnChanges {
  @Input() allotmentRelatedData: any;
  @Input() allotmentContext: any;

  addressToAndFromAddressDetail: any;
  basicDetails = true;
  showSubmitButton: boolean = true;
  addressDetails = false;
  paymentDetails = false;
  documentDetails = false;
  isZoomed = false;
  allotmentForm!: FormGroup<any>;
  basicDetailsBlock = false;

  Submitted = false;
  familyDetails = false;
  coapplicantDetails = false;
  nomineeDetails = false;
  date!: Date;
  emergencyDetails = false;
  familyColumnDefs: any[] = [];
  coApplicantColumnDefs: any[] = [];
  nomineeColumnDefs: any[] = [];
  otherChargesColumnDefs: any[] = [];
  familyRowdata: any;
  otherChargesRowData: any;
  coAppRowData: any;
  nomineeRowData: any;
  bloodGroups: any[] = [];
  formIdentity!: FormIdentity;
  showDetailedModal: boolean = false;
  paymentScheduleColumnDefs: any[] = paymentSchedule;
  selectedPaymentPlan: any;
  saleRate!: number;





  referenceList: any[] = referenceList;

  formDataConfig: any = null;

  editIcon: string = environment.assetsImagePath + IconList.ActionEditIcon;
  deleteIcon: string = environment.assetsImagePath + IconList.ActionDeleteIcon;

  summaryColumnDefs!: any[];
  summaryData!: TreeNode[];
  summaryOtherCharges!: TreeNode[];
  usersCategory: UsersCategory[] | undefined;
  selectedCategory: UsersCategory | undefined;
  users: Users[] | undefined;
  selectedUser: Users | undefined;
  showOtherChargesModal: boolean = false;
  otherChargesCols!: any[];
  otherChargesTableData!: any[];

  selectedReference: any;
  showClientIcon: boolean = true;
  tableData: any[] = [{}, {}];


  activeTab: number = 1;



  taxTypes: any[] = [
    { label: 'GST', value: 'GST' },
    { label: 'VAT', value: 'VAT' }
  ];

  taxSubTypes: any[] = [
    { label: 'GST-5%', value: 'GST-5%' },
    { label: 'GST-9%', value: 'GST-9%' },
    { label: 'GST-18%', value: 'GST-18%' },
    { label: 'GST-28%', value: 'GST-28%' }
  ];
  constructor(public commonService: CommonService,
    private userService: UserService, private fb: FormBuilder,
    public salesService: SalesService, private cdr: ChangeDetectorRef) {
    this.date = new Date;
    this.usersCategory = [
      {
        name: 'Applicant', items: [
          { id: 1, name: 'Mohit Singh' }
        ]
      },
      {
        name: 'Co-Applicant', items: [
          { id: 1, name: 'Rohit Singh' }
        ]
      },
      {
        name: 'Nominee', items: [
          { id: 1, name: 'Hitesh Kumar' }
        ]
      },
      {
        name: 'Family Members', items: [
          { id: 1, name: 'Rahul Singhaniya' }
        ]
      }
    ];

    this.summaryColumnDefs = summaryColumnDefs;
    this.summaryData = summaryData;
    this.summaryOtherCharges = summaryTreeNodes;
    this.otherChargesColumnDefs = otherChargesColDefs;
  }

  ngOnInit(): void {
    this.commonService.isTabSelected(0)

    this.initiateForm();

    // this.getBloodGroupList();
    this.otherChargesRowData = [];
    this.summaryColumnDefs = summaryColumnDefs;
    this.summaryData = summaryData;
    this.summaryOtherCharges = summaryTreeNodes;
    this.otherChargesColumnDefs = otherChargesColDefs
    this.init();

    this.otherChargesCols = [
      {
        field: 'heads',
        header: 'Head'
      },
      {
        field: 'atRate',
        header: 'At Rate'
      },
      {
        field: 'amount',
        header: 'Amount'
      },
    ];
    this.otherChargesTableData = [
      {
        heads: ['Car Parking', 'Power Backup', 'Maintenance'],
        atRate: '',
        amount: '',
      },
      {
        heads: ['GST-5%', 'GST-12%', 'GST-18%', 'GST-28%'],
        atRate: '',
        amount: '',
      },
      {
        heads: 'Gross Amount',
        atRate: '',
        amount: '',
      },
      {
        heads: 'Discount',
        atRate: '',
        amount: '',
      },
      {
        heads: 'CGST',
        atRate: '',
        amount: '',
      },
      {
        heads: 'SGST',
        atRate: '',
        amount: '',
      },
      {
        heads: 'IGST',
        atRate: '',
        amount: '',
      },
      {
        heads: 'Bill Amount',
        atRate: '',
        amount: '',
      },
      {
        heads: 'Round Off',
        atRate: '',
        amount: '',
      },
      {
        heads: 'Net Amount',
        atRate: '',
        amount: '',
      }
    ]
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  private init() {
    setTimeout(() => {
      if (this.allotmentRelatedData?.isNewCustomer) {
        this.showClientIcon = false;
        this.allotmentForm.reset();
        this.allotmentForm.controls['allotmentDate'].setValue(new Date());
        this.allotmentForm.controls['bookingDate'].setValue(new Date());
        const newCust = referenceList.find((i: any) => i.value == References.newCustomer);
        //this.allotmentForm.controls['referenceNumber'].setValue(newCust);
      } else {
        this.setBookingDataInForm();
      }
    });
  }

  initiateForm() {
    this.allotmentForm = this.fb.group({
      id: [0],
      referenceNumber: ['', [Validators.required]],
      clientId: [0],
      crmRefLeadId: [0],
      sourceType: ['', [Validators.required]],
      sourceName: ['', [Validators.required]],
      nameInitialsId: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: [''],
      relationInitialsId: ['', [Validators.required]],
      parentName: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      bloodGroup: [''],
      nationality: ['', [Validators.required]],
      pan: ['', [Validators.required, this.panValidator]],
      uidType: ['', [Validators.required]],
      uidNumber: ['', [Validators.required]],
      email: ['', [Validators.email]],
      contactNumber: ['', [Validators.required]],
      secondaryPhoneNo: [''],
      unitCategory: ['', [Validators.required]],
      unitDescription: ['', [Validators.required]],
      dateOfBirth: ['', [Validators.required]],
      weddingAnniversary: [''],
      bookingDate: ['', [Validators.required]],
      allotmentDate: ['', [Validators.required]],
      companyName: [''],
      firmPan: [''],
      officeAddress: [''],
      natureOfBusiness: [''],
      firmgstNumber: [''],
      emergencyName: [''],
      emergencyContactNumber: [''],
      emergencyRelation: [''],
      taxStructure: ['', [Validators.required]],
      taxSubType: [''],
      selectedTaxStructureForOtherCharges: [''],
      paymentPlan: [(this.salesService?.currentBooking?.paymentPlanDetail?.name) ? (this.salesService?.currentBooking?.paymentPlanDetail?.name) : this.selectedPaymentPlan, [Validators.required]],
      saleRate: ['', [Validators.required]]
    })
  }

  panValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN pattern
    const valid = panPattern.test(control.value);
    return valid ? null : { invalidPan: true };
  }

  showBasicDetails() {
    this.commonService.selectTab(0)
  }

  showPaymentDetails() {
    this.commonService.selectTab(2)
  }
  setBookingDataInForm() {
    if (this.salesService?.currentBooking) {
      const ref = referenceList.find((i: any) => i.value == References.bookingRef);

      setTimeout(() => {
        this.allotmentForm.controls['referenceNumber'].setValue(ref);
      });

      this.allotmentForm.controls['allotmentDate'].setValue(new Date());

      this.allotmentForm.patchValue({
        sourceName: this.salesService?.currentBooking?.sourceName,
        sourceType: this.salesService?.currentBooking?.sourceTypeDetail?.name,
        firstName: this.salesService?.currentBooking?.customerDetail?.firstName,
        lastName: this.salesService?.currentBooking?.customerDetail?.lastName,
        pan: this.salesService?.currentBooking?.customerDetail?.panCardNo,
        contactNumber: this.salesService?.currentBooking?.contactNumber,
        unitCategory: this.salesService?.currentBooking?.product,
        nameInitialsId: this.salesService?.currentBooking?.customerDetail?.nameInitialsName,
        bookingDate: new Date(this.salesService?.currentBooking?.bookingDate),
        paymentPlan: this.salesService?.currentBooking?.paymentPlanDetail?.name
      })
    } else {
      const ref = referenceList.find(i => i.value == References.newCustomer);
      this.allotmentForm.controls['referenceNumber'].setValue(ref);
    }
  }

  basicDetail() {
    this.addressDetails = false;
    this.paymentDetails = false;
    this.documentDetails = false;
    this.basicDetails = true;
    setTimeout(() => {
      this.allotmentForm.markAllAsTouched();
      this.init();
    });
  }

  addressDetail() {
    this.basicDetails = false;
    this.paymentDetails = false;
    this.documentDetails = false;
    setTimeout(() => {
      this.addressDetails = true;
      this.allotmentForm.markAllAsTouched();
    });
  }

  documentDetail() {
    this.basicDetails = false;
    this.addressDetails = false;
    this.paymentDetails = false;
    setTimeout(() => {
      this.documentDetails = true;
    });
  }

  paymentDetail() {
    this.basicDetails = false;
    this.addressDetails = false;
    this.documentDetails = false;

    setTimeout(() => {
      this.paymentDetails = true;
      this.allotmentForm.markAllAsTouched();
    });
  }


  enablePaymentPlan: boolean = false;
  paymentPlanValidation() {
    if (this.allotmentForm.controls['unitCategory']
      && this.allotmentForm.controls['paymentDetails.saleRate']
    ) {
      this.enablePaymentPlan = true;
    } else {
      this.enablePaymentPlan = false;
    }
  }


  Close() {

  }


  // toggleBasicDetails() {
  //   this.basicDetailsBlock = !this.basicDetailsBlock;
  // }

  togglefamilyDetails() {
    this.familyDetails = !this.familyDetails
  }

  toggleCoApplicantDetails() {
    this.coapplicantDetails = !this.coapplicantDetails
  }

  toggleNomineeDetails() {
    this.nomineeDetails = !this.nomineeDetails
  }

  toggleEmergencyDetails() {
    this.emergencyDetails = !this.emergencyDetails
  }

  setCustomerData() {
    if (this.allotmentRelatedData) {
      this.allotmentForm.patchValue({
        name: this.allotmentRelatedData.name,
        fatherName: this.allotmentRelatedData.fatherName,
        contactNo: this.allotmentRelatedData.contactNo,
        email: this.allotmentRelatedData.email,
        address: this.allotmentRelatedData.address,
        permanentAddress: this.allotmentRelatedData.permanentAddress,
        adharcardNo: this.allotmentRelatedData.adharcardNo,
        pancardNo: this.allotmentRelatedData.pancardNo,
        religion: this.allotmentRelatedData.religion,
        community: this.allotmentRelatedData.community,
        ifsc: this.allotmentRelatedData.ifsc,
        bankAccountNo: this.allotmentRelatedData.bankAccountNo,
        accountHolderName: this.allotmentRelatedData.accountHolderName,
        branchAddress: this.allotmentRelatedData.branchAddress,
        branchName: this.allotmentRelatedData.branchName,
        userId: 1014
      });
    }
  }


































  submitOtherChargesData() {

  }

  // Switch tabs
  selectTab(tabNumber: number): any {
    this.activeTab = tabNumber;
  }

  onSubmit() {
    // if(this.allotmentForm.valid){

    // }else{
    //   console.error('Form is invalid');
    // }
  }
}
